var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from '~/core/decorator';
import { FilterService } from '~/utils/filter.service';
var CaseAssistService = /** @class */ (function () {
    function CaseAssistService() {
    }
    /**
     * 获取协催管理-外访待分配-数据显示
     */
    CaseAssistService.prototype.getAllWaitVisitCaseAssist = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseAssistController.getAllWaitVisitCaseAssist,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                personalName: data.personalName,
                idCard: data.idCard,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                mobileNo: data.mobileNo,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mainDeptName: data.mainDeptName,
                currentCollectorRealName: data.currentCollectorRealName,
                loanAmountMin: data.loanAmount ? data.loanAmount.min : '',
                loanAmountMax: data.loanAmount ? data.loanAmount.max : '',
                loanPeriodMin: data.loanPeriod ? data.loanPeriod.min : '',
                loanPeriodMax: data.loanPeriod ? data.loanPeriod.max : '',
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                plateNum: data.plateNum,
                collectionType: data.collectionType,
                flowInTimeMin: FilterService.dateRanageFormat(data.flowInTime).start,
                flowInTimeMax: FilterService.dateRanageFormat(data.flowInTime).end,
                personalCollectionRemainingDaysMin: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.min : '',
                personalCollectionRemainingDaysMax: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.max : '',
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 获取协催管理-电催待分配-数据显示
     */
    CaseAssistService.prototype.getAllWaitTelCaseAssist = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseAssistController.getAllWaitTelCaseAssist,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                personalName: data.personalName,
                idCard: data.idCard,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                mobileNo: data.mobileNo,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mainDeptName: data.mainDeptName,
                currentCollectorRealName: data.currentCollectorRealName,
                loanAmountMin: data.loanAmount ? data.loanAmount.min : '',
                loanAmountMax: data.loanAmount ? data.loanAmount.max : '',
                loanPeriodMin: data.loanPeriod ? data.loanPeriod.min : '',
                loanPeriodMax: data.loanPeriod ? data.loanPeriod.max : '',
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                plateNum: data.plateNum,
                collectionType: data.collectionType,
                flowInTimeMin: FilterService.dateRanageFormat(data.flowInTime).start,
                flowInTimeMax: FilterService.dateRanageFormat(data.flowInTime).end,
                personalCollectionRemainingDaysMin: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.min : '',
                personalCollectionRemainingDaysMax: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.max : '',
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 获取协催管理-法务待分配-数据显示
     */
    CaseAssistService.prototype.getAllWaitLegalCaseAssist = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseAssistController.getAllWaitLegalCaseAssist,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                personalName: data.personalName,
                idCard: data.idCard,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                mobileNo: data.mobileNo,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mainDeptName: data.mainDeptName,
                currentCollectorRealName: data.currentCollectorRealName,
                loanAmountMin: data.loanAmount ? data.loanAmount.min : '',
                loanAmountMax: data.loanAmount ? data.loanAmount.max : '',
                loanPeriodMin: data.loanPeriod ? data.loanPeriod.min : '',
                loanPeriodMax: data.loanPeriod ? data.loanPeriod.max : '',
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                plateNum: data.plateNum,
                collectionType: data.collectionType,
                flowInTimeMin: FilterService.dateRanageFormat(data.flowInTime).start,
                flowInTimeMax: FilterService.dateRanageFormat(data.flowInTime).end,
                personalCollectionRemainingDaysMin: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.min : '',
                personalCollectionRemainingDaysMax: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.max : '',
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 协催管理-外访催收-数据显示
     */
    CaseAssistService.prototype.getAllVisitCaseAssist = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseAssistController.getAllVisitCaseAssist,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                personalName: data.personalName,
                idCard: data.idCard,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                mobileNo: data.mobileNo,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mainDeptName: data.mainDeptName,
                currentCollectorRealName: data.currentCollectorRealName,
                loanAmountMin: data.loanAmount ? data.loanAmount.min : '',
                loanAmountMax: data.loanAmount ? data.loanAmount.max : '',
                loanPeriodMin: data.loanPeriod ? data.loanPeriod.min : '',
                loanPeriodMax: data.loanPeriod ? data.loanPeriod.max : '',
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                plateNum: data.plateNum,
                collectionType: data.collectionType,
                flowInTimeMin: FilterService.dateRanageFormat(data.flowInTime).start,
                flowInTimeMax: FilterService.dateRanageFormat(data.flowInTime).end,
                personalCollectionRemainingDaysMin: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.min : '',
                personalCollectionRemainingDaysMax: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.max : '',
                deptId: data.deptId ? (data.deptId.length === 0 ? '' : data.deptId[data.deptId.length - 1]) : '',
                assistCollectorName: data.assistCollectorName,
                flag: data.flag,
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 协催管理-电催催收-数据显示
     */
    CaseAssistService.prototype.getAllTelCaseAssist = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseAssistController.getAllTelCaseAssist,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                personalName: data.personalName,
                idCard: data.idCard,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                mobileNo: data.mobileNo,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mainDeptName: data.mainDeptName,
                currentCollectorRealName: data.currentCollectorRealName,
                loanAmountMin: data.loanAmount ? data.loanAmount.min : '',
                loanAmountMax: data.loanAmount ? data.loanAmount.max : '',
                loanPeriodMin: data.loanPeriod ? data.loanPeriod.min : '',
                loanPeriodMax: data.loanPeriod ? data.loanPeriod.max : '',
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                plateNum: data.plateNum,
                collectionType: data.collectionType,
                flowInTimeMin: FilterService.dateRanageFormat(data.flowInTime).start,
                flowInTimeMax: FilterService.dateRanageFormat(data.flowInTime).end,
                personalCollectionRemainingDaysMin: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.min : '',
                personalCollectionRemainingDaysMax: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.max : '',
                deptId: data.deptId ? (data.deptId.length === 0 ? '' : data.deptId[data.deptId.length - 1]) : '',
                assistCollectorName: data.assistCollectorName,
                flag: data.flag,
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 协催管理-法务催收-数据显示
     */
    CaseAssistService.prototype.getAllLegalCaseAssist = function (data, page, sort) {
        return this.netService.send({
            server: domainService.caseAssistController.getAllLegalCaseAssist,
            data: {
                caseNumber: data.caseNumber,
                batchNumber: data.batchNumber,
                principalId: data.principalId,
                personalName: data.personalName,
                idCard: data.idCard,
                loanDateMin: FilterService.dateRanageFormat(data.loanDate).start,
                loanDateMax: FilterService.dateRanageFormat(data.loanDate).end,
                mobileNo: data.mobileNo,
                partnerName: data.partnerName,
                bankName: data.bankName,
                mainDeptName: data.mainDeptName,
                currentCollectorRealName: data.currentCollectorRealName,
                loanAmountMin: data.loanAmount ? data.loanAmount.min : '',
                loanAmountMax: data.loanAmount ? data.loanAmount.max : '',
                loanPeriodMin: data.loanPeriod ? data.loanPeriod.min : '',
                loanPeriodMax: data.loanPeriod ? data.loanPeriod.max : '',
                overdueAmountMin: data.overdueAmount ? data.overdueAmount.min : '',
                overdueAmountMax: data.overdueAmount ? data.overdueAmount.max : '',
                businessAddress: data.businessAddress,
                boardAddress: data.boardAddress,
                plateNum: data.plateNum,
                collectionType: data.collectionType,
                flowInTimeMin: FilterService.dateRanageFormat(data.flowInTime).start,
                flowInTimeMax: FilterService.dateRanageFormat(data.flowInTime).end,
                personalCollectionRemainingDaysMin: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.min : '',
                personalCollectionRemainingDaysMax: data.personalCollectionRemainingDays ? data.personalCollectionRemainingDays.max : '',
                deptId: data.deptId ? (data.deptId.length === 0 ? '' : data.deptId[data.deptId.length - 1]) : '',
                assistCollectorName: data.assistCollectorName,
                flag: data.flag,
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 协催管理-外访待分配-分案
     */
    CaseAssistService.prototype.confirmDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.caseAssistController.distributeCaseAssist,
            data: data,
        });
    };
    /**
     * 协催管理-案件标色
     */
    CaseAssistService.prototype.markCaseAssistColor = function (data) {
        return this.netService.send({
            server: domainService.caseAssistController.markCaseAssistColor,
            data: data,
        });
    };
    /**
     * 协催团队案件池-回收协催案件
     * @param data
     * @returns
     */
    CaseAssistService.prototype.returnCoUrging = function (data) {
        return this.netService.send({
            server: domainService.caseAssistController.returnCoUrging,
            data: data,
        });
    };
    __decorate([
        Inject(NetService)
    ], CaseAssistService.prototype, "netService", void 0);
    return CaseAssistService;
}());
export { CaseAssistService };
